import React from 'react';

function About() {
  return (
    <div className="about-container">
      <h1>Contact</h1>
      <div className="about-content">
        <p>
          ALEPH MEDIA SRL în insolvență, persoană juridică română cu sediul în București, 
          str. Polizu Gheorghe nr.58-60, etaj 3, camera 7, sector 1 cu punct de lucru / 
          adresă de corespondență în București, sector 1, Bulevardul Aviatorilor nr. 45, 
          etajele 4 și 5, înmatriculată la Oficiul Registrului Comerțului București sub 
          nr. J40/12688/2016, CUI 36570266.
        </p>

        <h2>Coordonate</h2>
        <p>
          <strong>E-mail:</strong> redactie@alephmedia.ro<br />
          <strong>Telefon:</strong> +40(0)31.8256.410<br />
          <strong>Mobil:</strong> +40 757 741 741
        </p>

        <h2>Colectivul redacțional</h2>
        <ul>
          <li>Maria Sandu - maria.sandu@alephmedia.ro</li>
          <li>Diana Nechita - diana.nechita@alephmedia.ro</li>
          <li>Mihaela Păun - mihaela.paun@alephmedia.ro</li>
          <li>Diana Zlătescu - diana.zlatescu@alephmedia.ro</li>
          <li>Diana Mihalașcu - diana.mihalascu@alephmedia.ro</li>
          <li>Iustina Mihai - iustina.mihai@alephmedia.ro</li>
          <li>Briana Lupea - briana.lupea@alephmedia.ro</li>
        </ul>

        <h2>Departamente</h2>
        <p>
          <strong>Vânzări:</strong> Mihaela Mihalcea - mihaela.mihalcea@outsmart.media (0753066125)<br />
          <strong>Distribuție:</strong> Costinela Roșu - costinela.rosu@alerria.ro<br />
          <strong>Resurse Umane:</strong> Mihaela Antofi - hr@alephmedia.ro
        </p>
      </div>
    </div>
  );
}

export default About; 